import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container is-fluid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Search in project", -1)
const _hoisted_3 = { class: "columns is-multiline" }
const _hoisted_4 = { class: "column is-one-quarter-desktop is-full" }
const _hoisted_5 = { class: "select is-fullwidth mb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, "Choose a project", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { class: "columns is-multiline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchForm = _resolveComponent("SearchForm")!
  const _component_SearchResult = _resolveComponent("SearchResult")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCorpusId) = $event))
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indexableCorpora, (corpus) => {
              return (_openBlock(), _createElementBlock("option", {
                key: corpus.id,
                value: corpus.id
              }, _toDisplayString(corpus.name), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedCorpusId]
          ])
        ]),
        (_ctx.corpusId)
          ? (_openBlock(), _createBlock(_component_SearchForm, {
              key: 0,
              "corpus-id": _ctx.corpusId,
              "all-facets": _ctx.documents?.facets,
              loading: _ctx.loading,
              modelValue: _ctx.query,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event))
            }, null, 8, ["corpus-id", "all-facets", "loading", "modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Paginator, {
          response: _ctx.documents,
          "bottom-bar": "",
          page: _ctx.page,
          "onUpdate:page": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page) = $event))
        }, {
          default: _withCtx(({ results }) => [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results, (document) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "column is-one-quarter-desktop is-one-third",
                  key: document.id
                }, [
                  _createVNode(_component_SearchResult, { document: document }, null, 8, ["document"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["response", "page"])
      ])
    ])
  ]))
}